/* eslint-disable */
interface ICacheOptions{
	/**
	 * doba platnosti zaznamu v milisekundach (time to live), default = 1000
	 */
	ttl?: number,
	 /**
	 * interval v milisekundach po kterem se kontroluje platnost ulozenych zaznamu, default = 1000
	 */
	interval?: number,
}

interface ICacheItem {
	/**
	 * ulozena data
	 */
	data: any,
	/**
	 * jak dlouho ma byt zaznam validni v milisekundach
	 */
	validTo: number,
}

class Cache {
	#options: ICacheOptions;
	#cache: {
		[key: number]: ICacheItem
	};
	#interval: number;

	constructor(options?: ICacheOptions) {
		this.#options = {
			ttl: 1000,
			interval: 1000,
			...options ? options : {},
		};
		this.#cache = {};
		this.#interval = null;
	}

	destroy() {
		this.#cache = {};
		this.#clearInterval();
	}

	get options() {
		return {
			...this.#options,
		}
	}

	/**
	 * Vytahne data k zadanemu klici
	 * @param key klic zaznamu
	 * @returns
	 */
	get(key) {
		if (!key) { throw Error("Key, for read in cache, not defined."); }
		return this.#cache[key]?.data;
	}

	/**
	 * Ulozi data pod zadanym klicem, pokud data nejsou, ulozi prazdnou hodnotu podle zadanych options
	 * @param key klic pod kterym budou data ulozena
	 * @param data data pro ulozeni
	 * @param ttl doba platnosti zaznamu v milisekundach, pokud neni zadano, ridi se nastavenim tridy
	 * @returns objekt s klicem a hodnotou do kdy bude zaznam uchovan
	 */
	put(key: string, data?: any, ttl?: number): {
		key: string,
		validTo: number,
		type: "update" | "new",
	} {
		if (!key) { throw Error("Key, for save to cache, not defined."); }

		if (!Object.keys(this.#cache).length) {
			this.#setInterval();
		}

		let validTo = Date.now() + (ttl ? ttl : this.#options.ttl);
		let update = !!this.#cache[key];

		this.#cache[key] = {
			data,
			validTo,
		};

		return {
			key,
			validTo,
			type: update ? "update" : "new",
		};
	}

	/**
	 * Smaze ulozena data na danem klici
	 * @param key klic pod kterym jsou data ulozena
	 * @returns zda klic pred smazanim existoval ci nikoliv
	 */
	delete(key): boolean {
		if (!key) { throw Error("Key, for remove from cache, not defined."); }
		let find = false;

		if (this.#cache[key]) {
			delete this.#cache[key];
			find = true;
		}

		if (!Object.keys(this.#cache).length) {
			this.#clearInterval();
		}

		return find;
	}

	/**
	 * nasatvi interval pro kontrolu starych zaznamu, bezi jen pokud mame ulozena nejaka data
	 * @private
	 */
	#setInterval() {
		this.#interval = window.setInterval(() => {
			for (let key in this.#cache) {
				if (this.#cache[key].validTo <= Date.now()) {
					this.delete(key);
				}
			}
		}, this.#options.interval);
	}

	/**
	 * zastaveni intervalu kontroly starych zaznamu
	 * @private
	 */
	#clearInterval() {
		if (this.#interval) {
			window.clearInterval(this.#interval);
			this.#interval = null;
		}
	}
}

export class LocalCache extends Cache {
	/**
	 * vymaze celou cache
	 */
	flush() {
		this.destroy()
	}
}

export default new Cache();
